export class TxnApprovalInfo {
    id: number;
    name: string;
    actionDate: number;
    actionTaken: string;
    responseMessage: string;
}